const map = {
	"./cancellation_by_deposit.svg": 644,
	"./cancellation_by_hotel.svg": 428,
	"./cancellation_by_origin.svg": 748,
	"./client_flexibility.svg": 881,
	"./client_flexibility_bubble.svg": 6,
	"./client_flexibility_pie.svg": 650,
	"./lead_time_cancellation.svg": 740,
	"./market_segment_cancellation.svg": 328,
	"./monthly_occupancy.svg": 49,
	"./revenue_by_meal_plan.svg": 236,
	"./seasonal_pattern.svg": 59,
	"./stay_by_origin.svg": 986,
	"./stay_duration.svg": 178,
	"./weekly_occupation_adr.svg": 707,
	"./weekly_revenue.svg": 172,
	"./yearly_seasonality.svg": 571
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 927;